// // import { useState } from "react";
// // import { toast } from "react-toastify";
// // //prettier-ignore
// // import { Box, Button, Step, StepLabel, Stepper, Grid } from "@mui/material";
// // import { ExecuteApiToPost } from "../../../../services/api/ExecuteApiRequests";
// // import BasicInfo from "./RegisterProspectiveInvestor/BasicInfo";
// // import PIAddress from "./RegisterProspectiveInvestor/PIAddress";
// // import PIAttachment from "./RegisterProspectiveInvestor/PIAttachment";
// // import FormContainer from "../../../../components/Forms/FormContainer";

// // //import {BasicInfo, PIAddress, PIAttachment} from './RegisterProspectiveInvestor';
// // //prettier-ignore
// // const INITIAL_FORM_DATA = { id: "", tin_no: "0000000000", reg_date: "", registered_by: "", company_name: "", contact_person: "", phone_no: "", mobile_no: "",
// //   email: "", website: "", nationality_origin: "", city: "", specific_location: "", description: "",
// //   application_file: "", license: "", propsal_attached: "", legal_documents: ""};

// // const steps = ["Basic Info", "PI Address", "PI Attachment"];
// // const RegisterProspectiveInvestor = () => {
// //   const [formData, setFormData] = useState(INITIAL_FORM_DATA);
// //   const [activeStep, setActiveStep] = useState(0);

// //   const handleNext = () => {
// //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
// //   };

// //   const handleBack = () => {
// //     setActiveStep((prevActiveStep) => prevActiveStep - 1);
// //   };

// //   const handleReset = () => {
// //     setFormData(INITIAL_FORM_DATA);
// //     setActiveStep(0);
// //   };

// //   const updateFields = (fields) => {
// //     setFormData((prev) => {
// //       return { ...prev, ...fields };
// //     });
// //   };

// //   const saveDataToDb = async () => {
// //     try {
// //       const formDataToSubmit = new FormData();
// //       formDataToSubmit.append("data", JSON.stringify(formData));
// //       formDataToSubmit.append("application", formData.application_file);
// //       formDataToSubmit.append("license", formData.license);
// //       formDataToSubmit.append("proposal", formData.propsal_attached);
// //       formDataToSubmit.append("legal_documents", formData.legal_documents);
// //       const response = await ExecuteApiToPost("prospectiveInvestors", formDataToSubmit);

// //       if (response) {
// //         //prettier-ignore
// //         toast("Prospective investor registration is successful!", { type: "success", position: "bottom-right", autoClose: 3000 });
// //         return true;
// //       } else {
// //         //prettier-ignore
// //         toast("Prospective investor registration failed: " + response, { type: "error", position: "bottom-right", autoClose: 3000 });
// //         return false;
// //       }
// //     } catch (error) {
// //       toast(error.message, { type: "error", position: "bottom-right", autoClose: 3000 });
// //       return false;
// //     }
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     if (activeStep === steps.length - 1) {
// //       if (await saveDataToDb()) {
// //         handleReset();
// //       }
// //     } else {
// //       handleNext();
// //     }
// //   };

// //   const getStepContent = (step) => {
// //     switch (step) {
// //       case 0:
// //         return <BasicInfo {...formData} updateFields={updateFields} />;
// //       case 1:
// //         return <PIAddress {...formData} updateFields={updateFields} />;
// //       case 2:
// //         return <PIAttachment {...formData} updateFields={updateFields} />;
// //       default:
// //         return "Unknown step";
// //     }
// //   };

// //   return (
// //     <FormContainer title="Prospective Investor Registration" onSubmit={handleSubmit} showButton={false}>
// //       <Grid item xs={12}>
// //         <Stepper activeStep={activeStep}>
// //           {steps.map((label, index) => (
// //             <Step key={index}>
// //               <StepLabel>{label}</StepLabel>
// //             </Step>
// //           ))}
// //         </Stepper>
// //       </Grid>
// //       {getStepContent(activeStep)}
// //       <Grid item xs={12}>
// //         <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
// //           <Button disabled={activeStep === 0} onClick={handleBack} sx={{ mr: 1 }}>
// //             Back
// //           </Button>
// //           <Button type="submit">{activeStep === steps.length - 1 ? "Register" : "Next"}</Button>
// //         </Box>
// //       </Grid>
// //     </FormContainer>
// //   );
// // };

// // export default RegisterProspectiveInvestor;

// /////////////////////
// // import { useState } from "react";
// // import { toast } from "react-toastify";
// // //prettier-ignore
// // import { Box, Button, Step, StepLabel, Stepper, Grid } from "@mui/material";
// // import { ExecuteApiToPost } from "../../../../services/api/ExecuteApiRequests";
// // import BasicInfo from "./RegisterProspectiveInvestor/BasicInfo";
// // import PIAddress from "./RegisterProspectiveInvestor/PIAddress";
// // import PIAttachment from "./RegisterProspectiveInvestor/PIAttachment";
// // import FormContainer from "../../../../components/Forms/FormContainer";
// // import useDecodedUser from "../../../../services/hooks/useDecodedUser"; // Add this import

// // //prettier-ignore
// // const INITIAL_FORM_DATA = { 
// //   id: "", 
// //   tin_no: "0000000000", 
// //   reg_date: "", 
// //   registered_by: "", 
// //   company_name: "", 
// //   contact_person: "", 
// //   phone_no: "", 
// //   // mobile_no: "",
// //   email: "", 
// //   website: "", 
// //   nationality_origin: "", 
// //   city: "", 
// //   specific_location: "", 
// //   description: "",
// //   application_file: "", 
// //   license: "", 
// //   propsal_attached: "", 
// //   legal_documents: ""
// // };

// // const steps = ["Basic Info", "PI Address", "PI Attachment"];
// // const RegisterProspectiveInvestor = () => {
// //   const decodedUser = useDecodedUser(); // Add this hook
// //   const [formData, setFormData] = useState({
// //     ...INITIAL_FORM_DATA,
// //     registered_by: decodedUser?.full_name || "" // Initialize with user's full name
// //   });
// //   const [activeStep, setActiveStep] = useState(0);

// //   const handleNext = () => {
// //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
// //   };

// //   const handleBack = () => {
// //     setActiveStep((prevActiveStep) => prevActiveStep - 1);
// //   };

// //   const handleReset = () => {
// //     setFormData({
// //       ...INITIAL_FORM_DATA,
// //       registered_by: decodedUser?.full_name || "" // Reset with user's full name
// //     });
// //     setActiveStep(0);
// //   };

// //   const updateFields = (fields) => {
// //     setFormData((prev) => {
// //       return { ...prev, ...fields };
// //     });
// //   };

// //   const saveDataToDb = async () => {
// //     try {
// //       // Ensure registered_by is always set to current user's full name
// //       const finalFormData = {
// //         ...formData,
// //         registered_by: decodedUser?.full_name || formData.registered_by
// //       };

// //       const formDataToSubmit = new FormData();
// //       formDataToSubmit.append("data", JSON.stringify(finalFormData)); // Use finalFormData here
// //       formDataToSubmit.append("application", finalFormData.application_file);
// //       formDataToSubmit.append("license", finalFormData.license);
// //       formDataToSubmit.append("proposal", finalFormData.propsal_attached);
// //       formDataToSubmit.append("legal_documents", finalFormData.legal_documents);
      
// //       const response = await ExecuteApiToPost("prospectiveInvestors", formDataToSubmit);

// //       if (response) {
// //         //prettier-ignore
// //         toast("Prospective investor registration is successful!", { type: "success", position: "bottom-right", autoClose: 3000 });
// //         return true;
// //       } else {
// //         //prettier-ignore
// //         toast("Prospective investor registration failed: " + response, { type: "error", position: "bottom-right", autoClose: 3000 });
// //         return false;
// //       }
// //     } catch (error) {
// //       toast(error.message, { type: "error", position: "bottom-right", autoClose: 3000 });
// //       return false;
// //     }
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     if (activeStep === steps.length - 1) {
// //       if (await saveDataToDb()) {
// //         handleReset();
// //       }
// //     } else {
// //       handleNext();
// //     }
// //   };

// //   const getStepContent = (step) => {
// //     switch (step) {
// //       case 0:
// //         return <BasicInfo {...formData} updateFields={updateFields} />;
// //       case 1:
// //         return <PIAddress {...formData} updateFields={updateFields} />;
// //       case 2:
// //         return <PIAttachment {...formData} updateFields={updateFields} />;
// //       default:
// //         return "Unknown step";
// //     }
// //   };

// //   return (
// //     <FormContainer title="Prospective Investor Registration" onSubmit={handleSubmit} showButton={false}>
// //       <Grid item xs={12}>
// //         <Stepper activeStep={activeStep}>
// //           {steps.map((label, index) => (
// //             <Step key={index}>
// //               <StepLabel>{label}</StepLabel>
// //             </Step>
// //           ))}
// //         </Stepper>
// //       </Grid>
// //       {getStepContent(activeStep)}
// //       <Grid item xs={12}>
// //         <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
// //           <Button disabled={activeStep === 0} onClick={handleBack} sx={{ mr: 1 }}>
// //             Back
// //           </Button>
// //           <Button type="submit">{activeStep === steps.length - 1 ? "Register" : "Next"}</Button>
// //         </Box>
// //       </Grid>
// //     </FormContainer>
// //   );
// // };

// // export default RegisterProspectiveInvestor;
// // /////////////////////
// //************************************************************************************************** */

// // import { useState, useEffect } from "react";
// // //prettier-ignore
// // import { 
// //   Box, Button, Step, StepLabel, Stepper, Grid, 
// //   Typography, Table, TableBody, TableCell, TableContainer, 
// //   TableHead, TableRow, Paper, IconButton, Dialog, DialogTitle, 
// //   DialogContent, DialogActions, Snackbar, InputAdornment, 
// //   TablePagination, Tooltip, Tabs, Tab, TextField, Chip,
// //   CircularProgress  // Add CircularProgress import
// // } from "@mui/material";
// // import { Edit as EditIcon, Visibility as ViewIcon, Delete as DeleteIcon, Search as SearchIcon, Download as DownloadIcon } from "@mui/icons-material";
// // import * as XLSX from 'xlsx';
// // import { ExecuteApiToPost, ExecuteApiToPut, ExecuteApiToDelete, GetDataFromApiWithParamsAndGetResponse } from "../../../../services/api/ExecuteApiRequests";
// // import BasicInfo from "./RegisterProspectiveInvestor/BasicInfo";
// // import PIAddress from "./RegisterProspectiveInvestor/PIAddress";
// // import PIAttachment from "./RegisterProspectiveInvestor/PIAttachment";
// // import FormContainer from "../../../../components/Forms/FormContainer";
// // import useDecodedUser from "../../../../services/hooks/useDecodedUser";

// // //prettier-ignore
// // const INITIAL_FORM_DATA = { 
// //   id: "", 
// //   tin_no: "0000000000", 
// //   reg_date: "", 
// //   registered_by: "", 
// //   company_name: "", 
// //   contact_person: "", 
// //   phone_no: "", 
// //   email: "", 
// //   website: "", 
// //   nationality_origin: "", 
// //   city: "", 
// //   specific_location: "", 
// //   description: "",
// //   application_file: "", 
// //   license: "", 
// //   propsal_attached: "", 
// //   legal_documents: ""
// // };

// // const steps = ["Basic Info", "PI Address", "PI Attachment"];

// // const RegisterProspectiveInvestor = () => {
// //   const decodedUser = useDecodedUser();
// //   const [activeTab, setActiveTab] = useState(0);
// //   const [formData, setFormData] = useState({
// //     ...INITIAL_FORM_DATA,
// //     registered_by: decodedUser?.full_name || "",
// //     reg_date: new Date().toISOString().split('T')[0] // Set current date as default
// //   });
// //   const [activeStep, setActiveStep] = useState(0);
// //   const [investorsData, setInvestorsData] = useState([]);
// //   const [filteredInvestors, setFilteredInvestors] = useState([]);
// //   const [loadingInvestors, setLoadingInvestors] = useState(false);
// //   const [selectedInvestor, setSelectedInvestor] = useState(null);
// //   const [viewDialogOpen, setViewDialogOpen] = useState(false);
// //   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
// //   const [editingId, setEditingId] = useState(null);
// //   const [refreshKey, setRefreshKey] = useState(0);
// //   const [searchTerm, setSearchTerm] = useState("");
// //   const [page, setPage] = useState(0);
// //   const [rowsPerPage, setRowsPerPage] = useState(10);

// //   // Fetch investors data
// //   useEffect(() => {
// //     const fetchInvestors = async () => {
// //       try {
// //         setLoadingInvestors(true);
// //         const response = await GetDataFromApiWithParamsAndGetResponse("prospectiveInvestors");
        
// //         if (response && response.data) {
// //           setInvestorsData(response.data);
// //           setFilteredInvestors(response.data);
// //         }
// //       } catch (error) {
// //         console.error("Failed to fetch prospective investors:", error);
// //         setSnackbar({
// //           open: true,
// //           message: "Failed to load investors data",
// //           severity: "error"
// //         });
// //       } finally {
// //         setLoadingInvestors(false);
// //       }
// //     };

// //     if (activeTab === 1) {
// //       fetchInvestors();
// //     }
// //   }, [refreshKey, activeTab]);

// //   // Handle search functionality
// //   useEffect(() => {
// //     if (searchTerm.trim() === "") {
// //       setFilteredInvestors(investorsData);
// //     } else {
// //       const filtered = investorsData.filter(investor => {
// //         const searchLower = searchTerm.toLowerCase();
// //         return (
// //           (investor.company_name && investor.company_name.toLowerCase().includes(searchLower)) ||
// //           (investor.contact_person && investor.contact_person.toLowerCase().includes(searchLower)) ||
// //           (investor.tin_no && investor.tin_no.includes(searchTerm)) ||
// //           (investor.email && investor.email.toLowerCase().includes(searchLower)) ||
// //           (investor.phone_no && investor.phone_no.includes(searchTerm)) ||
// //           (investor.nationality_origin && investor.nationality_origin.toLowerCase().includes(searchLower)) ||
// //           (investor.city && investor.city.toLowerCase().includes(searchLower))
// //         );
// //       });
// //       setFilteredInvestors(filtered);
// //     }
// //     setPage(0);
// //   }, [searchTerm, investorsData]);

// //   const handleTabChange = (event, newValue) => {
// //     setActiveTab(newValue);
// //     if (newValue === 1) {
// //       setRefreshKey(prev => prev + 1);
// //       setSearchTerm("");
// //       setPage(0);
// //     } else {
// //       resetForm();
// //     }
// //   };

// //   const handleNext = () => {
// //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
// //   };

// //   const handleBack = () => {
// //     setActiveStep((prevActiveStep) => prevActiveStep - 1);
// //   };

// //   const handleReset = () => {
// //     setFormData({
// //       ...INITIAL_FORM_DATA,
// //       registered_by: decodedUser?.full_name || "",
// //       reg_date: new Date().toISOString().split('T')[0]
// //     });
// //     setActiveStep(0);
// //     setEditingId(null);
// //   };

// //   const updateFields = (fields) => {
// //     setFormData((prev) => {
// //       return { ...prev, ...fields };
// //     });
// //   };

// //   const saveDataToDb = async () => {
// //     try {
// //       // Ensure registered_by is always set to current user's full name
// //       const finalFormData = {
// //         ...formData,
// //         registered_by: decodedUser?.full_name || formData.registered_by
// //       };

// //       const formDataToSubmit = new FormData();
// //       formDataToSubmit.append("data", JSON.stringify(finalFormData));
// //       if (finalFormData.application_file) {
// //         formDataToSubmit.append("application", finalFormData.application_file);
// //       }
// //       if (finalFormData.license) {
// //         formDataToSubmit.append("license", finalFormData.license);
// //       }
// //       if (finalFormData.propsal_attached) {
// //         formDataToSubmit.append("proposal", finalFormData.propsal_attached);
// //       }
// //       if (finalFormData.legal_documents) {
// //         formDataToSubmit.append("legal_documents", finalFormData.legal_documents);
// //       }
      
// //       let response;
// //       if (editingId) {
// //         // Update existing investor
// //         response = await ExecuteApiToPut(`prospectiveInvestors/${editingId}`, formDataToSubmit);
// //       } else {
// //         // Create new investor
// //         response = await ExecuteApiToPost("prospectiveInvestors", formDataToSubmit);
// //       }

// //       if (response) {
// //         setSnackbar({
// //           open: true,
// //           message: editingId ? 
// //             "Prospective investor updated successfully!" : 
// //             "Prospective investor registration is successful!",
// //           severity: "success"
// //         });
// //         handleReset();
// //         setRefreshKey(prev => prev + 1);
// //         setActiveTab(1);
// //         return true;
// //       } else {
// //         setSnackbar({
// //           open: true,
// //           message: "Registration failed: " + response,
// //           severity: "error"
// //         });
// //         return false;
// //       }
// //     } catch (error) {
// //       setSnackbar({
// //         open: true,
// //         message: error.message || "An error occurred",
// //         severity: "error"
// //       });
// //       return false;
// //     }
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     if (activeStep === steps.length - 1) {
// //       await saveDataToDb();
// //     } else {
// //       handleNext();
// //     }
// //   };

// //   const getStepContent = (step) => {
// //     switch (step) {
// //       case 0:
// //         return <BasicInfo {...formData} updateFields={updateFields} />;
// //       case 1:
// //         return <PIAddress {...formData} updateFields={updateFields} />;
// //       case 2:
// //         return <PIAttachment {...formData} updateFields={updateFields} />;
// //       default:
// //         return "Unknown step";
// //     }
// //   };

// //   const handleEdit = (investor) => {
// //     setEditingId(investor.id);
    
// //     // Convert file objects if they exist in the response
// //     const transformedData = {
// //       ...investor,
// //       reg_date: investor.reg_date ? investor.reg_date.split('T')[0] : new Date().toISOString().split('T')[0],
// //       registered_by: investor.registered_by || decodedUser?.full_name || ""
// //     };
    
// //     setFormData(transformedData);
// //     setActiveTab(0);
// //     setActiveStep(0);
// //   };

// //   const handleView = (investor) => {
// //     setSelectedInvestor(investor);
// //     setViewDialogOpen(true);
// //   };

// //   const handleDelete = async (id) => {
// //     if (window.confirm("Are you sure you want to delete this prospective investor?")) {
// //       try {
// //         const response = await ExecuteApiToDelete(`prospectiveInvestors/${id}`);
// //         if (response) {
// //           setSnackbar({
// //             open: true,
// //             message: "Prospective investor deleted successfully!",
// //             severity: "success"
// //           });
// //           setRefreshKey(prev => prev + 1);
// //           setSearchTerm("");
// //           setPage(0);
// //         }
// //       } catch (error) {
// //         setSnackbar({
// //           open: true,
// //           message: "Failed to delete investor",
// //           severity: "error"
// //         });
// //         console.error("Error deleting investor:", error);
// //       }
// //     }
// //   };

// //   const handleSearchChange = (event) => {
// //     setSearchTerm(event.target.value);
// //   };

// //   const handleChangePage = (event, newPage) => {
// //     setPage(newPage);
// //   };

// //   const handleChangeRowsPerPage = (event) => {
// //     setRowsPerPage(parseInt(event.target.value, 10));
// //     setPage(0);
// //   };

// //   const exportToExcel = () => {
// //     try {
// //       const exportData = filteredInvestors.map((investor, index) => ({
// //         'No.': index + 1,
// //         'Registration Date': formatDate(investor.reg_date),
// //         'TIN No': investor.tin_no,
// //         'Company Name': investor.company_name,
// //         'Contact Person': investor.contact_person,
// //         'Phone No': investor.phone_no,
// //         'Email': investor.email,
// //         'Website': investor.website,
// //         'Nationality/Origin': investor.nationality_origin,
// //         'City': investor.city,
// //         'Specific Location': investor.specific_location,
// //         'Description': investor.description,
// //         'Registered By': investor.registered_by
// //       }));

// //       const ws = XLSX.utils.json_to_sheet(exportData);
// //       const wb = XLSX.utils.book_new();
// //       XLSX.utils.book_append_sheet(wb, ws, "Prospective Investors");
// //       const fileName = `Prospective_Investors_${new Date().toISOString().split('T')[0]}.xlsx`;
// //       XLSX.writeFile(wb, fileName);
      
// //       setSnackbar({
// //         open: true,
// //         message: `Exported ${exportData.length} investors to Excel`,
// //         severity: "success"
// //       });
// //     } catch (error) {
// //       console.error("Error exporting to Excel:", error);
// //       setSnackbar({
// //         open: true,
// //         message: "Failed to export data to Excel",
// //         severity: "error"
// //       });
// //     }
// //   };

// //   const handleCloseSnackbar = () => {
// //     setSnackbar({ ...snackbar, open: false });
// //   };

// //   const resetForm = () => {
// //     setFormData({
// //       ...INITIAL_FORM_DATA,
// //       registered_by: decodedUser?.full_name || "",
// //       reg_date: new Date().toISOString().split('T')[0]
// //     });
// //     setActiveStep(0);
// //     setEditingId(null);
// //   };

// //   const formatDate = (dateString) => {
// //     if (!dateString) return "N/A";
// //     try {
// //       return new Date(dateString).toLocaleDateString();
// //     } catch (error) {
// //       return dateString;
// //     }
// //   };

// //   const paginatedInvestors = filteredInvestors.slice(
// //     page * rowsPerPage,
// //     page * rowsPerPage + rowsPerPage
// //   );

// //   return (
// //     <>
// //       <Box sx={{ width: '100%' }}>
// //         <Tabs 
// //           value={activeTab} 
// //           onChange={handleTabChange}
// //           centered
// //           sx={{
// //             '& .MuiTabs-flexContainer': {
// //               gap: 4,
// //             },
// //             '& .MuiTabs-indicator': {
// //               backgroundColor: 'primary.main',
// //             },
// //             '& .MuiTab-root': {
// //               border: 'none',
// //               boxShadow: 'none',
// //               minWidth: 'auto',
// //               px: 4,
// //             }
// //           }}
// //         >
// //           <Tab label={editingId ? "Edit Investor" : "Register Investor"} />
// //           <Tab label="Edit Investors" />
// //         </Tabs>
        
// //         {activeTab === 0 && (
// //           <FormContainer 
// //             title={editingId ? "Edit Prospective Investor" : "Prospective Investor Registration"} 
// //             onSubmit={handleSubmit}
// //             onReset={editingId ? resetForm : null}
// //             showResetButton={editingId}
// //             resetButtonText="Cancel Edit"
// //             showButton={false}
// //           >
// //             <Grid item xs={12}>
// //               <Stepper activeStep={activeStep}>
// //                 {steps.map((label, index) => (
// //                   <Step key={index}>
// //                     <StepLabel>{label}</StepLabel>
// //                   </Step>
// //                 ))}
// //               </Stepper>
// //             </Grid>
            
// //             {getStepContent(activeStep)}
            
// //             <Grid item xs={12}>
// //               <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
// //                 <Button 
// //                   disabled={activeStep === 0} 
// //                   onClick={handleBack} 
// //                   sx={{ mr: 1 }}
// //                 >
// //                   Back
// //                 </Button>
// //                 <Button type="submit">
// //                   {activeStep === steps.length - 1 ? 
// //                     (editingId ? "Update" : "Register") : 
// //                     "Next"
// //                   }
// //                 </Button>
// //                 {editingId && (
// //                   <Button 
// //                     onClick={resetForm}
// //                     sx={{ ml: 1 }}
// //                     color="secondary"
// //                   >
// //                     Cancel Edit
// //                   </Button>
// //                 )}
// //               </Box>
// //             </Grid>
// //           </FormContainer>
// //         )}
        
// //         {activeTab === 1 && (
// //           <Box sx={{ mt: 3 }}>
// //             <Typography variant="h5" gutterBottom>
// //               Registered Prospective Investors
// //             </Typography>
            
// //             {/* Search Box */}
// //             <Box sx={{ width: '100%', mb: 3 }}>
// //               <TextField
// //                 variant="outlined"
// //                 placeholder="Search investors by company name, contact person, TIN, email..."
// //                 value={searchTerm}
// //                 onChange={handleSearchChange}
// //                 InputProps={{
// //                   startAdornment: (
// //                     <InputAdornment position="start">
// //                       <SearchIcon />
// //                     </InputAdornment>
// //                   ),
// //                 }}
// //                 sx={{ width: '50%' }}
// //                 size="small"
// //               />
// //             </Box>
            
// //             {/* Info and Export Section */}
// //             <Box sx={{ 
// //               display: 'flex', 
// //               justifyContent: 'space-between', 
// //               alignItems: 'center', 
// //               mb: 2 
// //             }}>
// //               <Box sx={{ display: 'flex', alignItems: 'center', gap: 110 }}>
// //                 <Typography variant="body2" color="text.secondary">
// //                   Showing {paginatedInvestors.length} of {filteredInvestors.length} investors
// //                   {searchTerm && ` matching "${searchTerm}"`}
// //                 </Typography>
// //                 <Tooltip title="Export to Excel">
// //                   <Button
// //                     variant="contained"
// //                     color="primary"
// //                     startIcon={<DownloadIcon />}
// //                     onClick={exportToExcel}
// //                     disabled={filteredInvestors.length === 0}
// //                     size="small"
// //                   >
// //                     Export
// //                   </Button>
// //                 </Tooltip>
// //               </Box>
              
// //               {searchTerm && (
// //                 <Button 
// //                   variant="outlined" 
// //                   size="small"
// //                   onClick={() => setSearchTerm("")}
// //                 >
// //                   Clear Search
// //                 </Button>
// //               )}
// //             </Box>
            
// //             {loadingInvestors ? (
// //               <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
// //                 <CircularProgress />
// //               </Box>
// //             ) : filteredInvestors.length === 0 ? (
// //               <Box sx={{ textAlign: 'center', mt: 4 }}>
// //                 <Typography variant="body1" color="text.secondary">
// //                   {searchTerm ? 
// //                     `No investors found matching "${searchTerm}"` : 
// //                     "No prospective investors registered yet."
// //                   }
// //                 </Typography>
// //                 {searchTerm && (
// //                   <Button 
// //                     variant="text" 
// //                     onClick={() => setSearchTerm("")}
// //                     sx={{ mt: 1 }}
// //                   >
// //                     Clear search
// //                   </Button>
// //                 )}
// //               </Box>
// //             ) : (
// //               <>
// //                 <Box sx={{ ml: 2 }}>
// //                   <TableContainer component={Paper}>
// //                     <Table>
// //                       <TableHead>
// //                         <TableRow>
// //                           <TableCell>#</TableCell>
// //                           <TableCell>Reg Date</TableCell>
// //                           <TableCell>TIN No</TableCell>
// //                           <TableCell>Company Name</TableCell>
// //                           <TableCell>Contact Person</TableCell>
// //                           <TableCell>Phone No</TableCell>
// //                           <TableCell>Email</TableCell>
// //                           <TableCell>City</TableCell>
// //                           <TableCell>Actions</TableCell>
// //                         </TableRow>
// //                       </TableHead>
// //                       <TableBody>
// //                         {paginatedInvestors.map((investor, index) => (
// //                           <TableRow key={investor.id}>
// //                             <TableCell>{page * rowsPerPage + index + 1}</TableCell>
// //                             <TableCell>{formatDate(investor.reg_date)}</TableCell>
// //                             <TableCell>
// //                               <Chip 
// //                                 label={investor.tin_no || "0000000000"} 
// //                                 size="small" 
// //                                 variant="outlined"
// //                               />
// //                             </TableCell>
// //                             <TableCell>{investor.company_name}</TableCell>
// //                             <TableCell>{investor.contact_person}</TableCell>
// //                             <TableCell>{investor.phone_no}</TableCell>
// //                             <TableCell>{investor.email}</TableCell>
// //                             <TableCell>{investor.city}</TableCell>
// //                             <TableCell>
// //                               <IconButton 
// //                                 color="primary" 
// //                                 onClick={() => handleView(investor)}
// //                                 size="small"
// //                                 title="View Details"
// //                               >
// //                                 <ViewIcon />
// //                               </IconButton>
// //                               <IconButton 
// //                                 color="secondary" 
// //                                 onClick={() => handleEdit(investor)}
// //                                 size="small"
// //                                 title="Edit"
// //                               >
// //                                 <EditIcon />
// //                               </IconButton>
// //                               <IconButton 
// //                                 color="error" 
// //                                 onClick={() => handleDelete(investor.id)}
// //                                 size="small"
// //                                 title="Delete"
// //                               >
// //                                 <DeleteIcon />
// //                               </IconButton>
// //                             </TableCell>
// //                           </TableRow>
// //                         ))}
// //                       </TableBody>
// //                     </Table>
                    
// //                     <TablePagination
// //                       rowsPerPageOptions={[5, 10, 25, 50, 100]}
// //                       component="div"
// //                       count={filteredInvestors.length}
// //                       rowsPerPage={rowsPerPage}
// //                       page={page}
// //                       onPageChange={handleChangePage}
// //                       onRowsPerPageChange={handleChangeRowsPerPage}
// //                       labelRowsPerPage="Rows per page:"
// //                     />
// //                   </TableContainer>
// //                 </Box>
// //               </>
// //             )}
// //           </Box>
// //         )}
// //       </Box>

// //       {/* View Dialog */}
// //       <Dialog 
// //         open={viewDialogOpen} 
// //         onClose={() => setViewDialogOpen(false)}
// //         maxWidth="md"
// //         fullWidth
// //       >
// //         <DialogTitle>Prospective Investor Details</DialogTitle>
// //         <DialogContent>
// //           {selectedInvestor && (
// //             <Grid container spacing={2} sx={{ mt: 1 }}>
// //               <Grid item xs={12} md={6}>
// //                 <Typography variant="subtitle2" color="text.secondary">Registration Date</Typography>
// //                 <Typography variant="body1">{formatDate(selectedInvestor.reg_date)}</Typography>
// //               </Grid>
// //               <Grid item xs={12} md={6}>
// //                 <Typography variant="subtitle2" color="text.secondary">TIN No</Typography>
// //                 <Typography variant="body1">{selectedInvestor.tin_no || "0000000000"}</Typography>
// //               </Grid>
// //               <Grid item xs={12} md={6}>
// //                 <Typography variant="subtitle2" color="text.secondary">Company Name</Typography>
// //                 <Typography variant="body1">{selectedInvestor.company_name}</Typography>
// //               </Grid>
// //               <Grid item xs={12} md={6}>
// //                 <Typography variant="subtitle2" color="text.secondary">Contact Person</Typography>
// //                 <Typography variant="body1">{selectedInvestor.contact_person}</Typography>
// //               </Grid>
// //               <Grid item xs={12} md={6}>
// //                 <Typography variant="subtitle2" color="text.secondary">Phone No</Typography>
// //                 <Typography variant="body1">{selectedInvestor.phone_no}</Typography>
// //               </Grid>
// //               <Grid item xs={12} md={6}>
// //                 <Typography variant="subtitle2" color="text.secondary">Email</Typography>
// //                 <Typography variant="body1">{selectedInvestor.email}</Typography>
// //               </Grid>
// //               <Grid item xs={12} md={6}>
// //                 <Typography variant="subtitle2" color="text.secondary">Website</Typography>
// //                 <Typography variant="body1">{selectedInvestor.website || "N/A"}</Typography>
// //               </Grid>
// //               <Grid item xs={12} md={6}>
// //                 <Typography variant="subtitle2" color="text.secondary">Nationality/Origin</Typography>
// //                 <Typography variant="body1">{selectedInvestor.nationality_origin}</Typography>
// //               </Grid>
// //               <Grid item xs={12} md={6}>
// //                 <Typography variant="subtitle2" color="text.secondary">City</Typography>
// //                 <Typography variant="body1">{selectedInvestor.city}</Typography>
// //               </Grid>
// //               <Grid item xs={12} md={6}>
// //                 <Typography variant="subtitle2" color="text.secondary">Specific Location</Typography>
// //                 <Typography variant="body1">{selectedInvestor.specific_location || "N/A"}</Typography>
// //               </Grid>
// //               <Grid item xs={12}>
// //                 <Typography variant="subtitle2" color="text.secondary">Description</Typography>
// //                 <Typography variant="body1">{selectedInvestor.description || "N/A"}</Typography>
// //               </Grid>
// //               <Grid item xs={12} md={6}>
// //                 <Typography variant="subtitle2" color="text.secondary">Registered By</Typography>
// //                 <Typography variant="body1">{selectedInvestor.registered_by}</Typography>
// //               </Grid>
// //               <Grid item xs={12} md={6}>
// //                 <Typography variant="subtitle2" color="text.secondary">Status</Typography>
// //                 <Chip 
// //                   label="Active" 
// //                   color="success" 
// //                   size="small" 
// //                   sx={{ mt: 0.5 }}
// //                 />
// //               </Grid>
// //             </Grid>
// //           )}
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={() => setViewDialogOpen(false)}>Close</Button>
// //         </DialogActions>
// //       </Dialog>

// //       {/* Snackbar for notifications */}
// //       <Snackbar
// //         open={snackbar.open}
// //         autoHideDuration={6000}
// //         onClose={handleCloseSnackbar}
// //         message={snackbar.message}
// //       />
// //     </>
// //   );
// // };

// // export default RegisterProspectiveInvestor;

// //888888888888888888888888888888888888888888
// import { useState, useEffect } from "react";
// //prettier-ignore
// import { 
//   Box, Button, Step, StepLabel, Stepper, Grid, 
//   Typography, Table, TableBody, TableCell, TableContainer, 
//   TableHead, TableRow, Paper, IconButton, Dialog, DialogTitle, 
//   DialogContent, DialogActions, Snackbar, InputAdornment, 
//   TablePagination, Tooltip, Tabs, Tab, TextField, Chip,
//   CircularProgress
// } from "@mui/material";
// import { Edit as EditIcon, Visibility as ViewIcon, Delete as DeleteIcon, Search as SearchIcon, Download as DownloadIcon } from "@mui/icons-material";
// import * as XLSX from 'xlsx';
// import { ExecuteApiToPost, ExecuteApiToPut, ExecuteApiToDelete, GetDataFromApiWithParamsAndGetResponse } from "../../../../services/api/ExecuteApiRequests";
// import BasicInfo from "./RegisterProspectiveInvestor/BasicInfo";
// import PIAddress from "./RegisterProspectiveInvestor/PIAddress";
// import PIAttachment from "./RegisterProspectiveInvestor/PIAttachment";
// import FormContainer from "../../../../components/Forms/FormContainer";
// import useDecodedUser from "../../../../services/hooks/useDecodedUser";

// //prettier-ignore
// const INITIAL_FORM_DATA = { 
//   id: "", 
//   tin_no: "0000000000", 
//   reg_date: "", 
//   registered_by: "", 
//   company_name: "", 
//   contact_person: "", 
//   phone_no: "", 
//   email: "", 
//   website: "", 
//   nationality_origin: "", 
//   city: "", 
//   specific_location: "", 
//   description: "",
//   application_file: "", 
//   license: "", 
//   propsal_attached: "", 
//   legal_documents: "",
//   documents_attached: []
// };

// const steps = ["Basic Info", "PI Address", "PI Attachment"];

// const RegisterProspectiveInvestor = () => {
//   const decodedUser = useDecodedUser();
//   const [activeTab, setActiveTab] = useState(0);
//   const [formData, setFormData] = useState({
//     ...INITIAL_FORM_DATA,
//     registered_by: decodedUser?.full_name || "",
//     reg_date: new Date().toISOString().split('T')[0]
//   });
//   const [activeStep, setActiveStep] = useState(0);
//   const [investorsData, setInvestorsData] = useState([]);
//   const [filteredInvestors, setFilteredInvestors] = useState([]);
//   const [loadingInvestors, setLoadingInvestors] = useState(false);
//   const [selectedInvestor, setSelectedInvestor] = useState(null);
//   const [viewDialogOpen, setViewDialogOpen] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
//   const [editingId, setEditingId] = useState(null);
//   const [refreshKey, setRefreshKey] = useState(0);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   // Fetch investors data
//   useEffect(() => {
//     const fetchInvestors = async () => {
//       try {
//         setLoadingInvestors(true);
//         const response = await GetDataFromApiWithParamsAndGetResponse("prospectiveInvestors");
        
//         if (response && response.data) {
//           setInvestorsData(response.data);
//           setFilteredInvestors(response.data);
//         }
//       } catch (error) {
//         console.error("Failed to fetch prospective investors:", error);
//         setSnackbar({
//           open: true,
//           message: "Failed to load investors data",
//           severity: "error"
//         });
//       } finally {
//         setLoadingInvestors(false);
//       }
//     };

//     if (activeTab === 1) {
//       fetchInvestors();
//     }
//   }, [refreshKey, activeTab]);

//   // Handle search functionality
//   useEffect(() => {
//     if (searchTerm.trim() === "") {
//       setFilteredInvestors(investorsData);
//     } else {
//       const filtered = investorsData.filter(investor => {
//         const searchLower = searchTerm.toLowerCase();
//         return (
//           (investor.company_name && investor.company_name.toLowerCase().includes(searchLower)) ||
//           (investor.contact_person && investor.contact_person.toLowerCase().includes(searchLower)) ||
//           (investor.tin_no && investor.tin_no.includes(searchTerm)) ||
//           (investor.email && investor.email.toLowerCase().includes(searchLower)) ||
//           (investor.phone_no && investor.phone_no.includes(searchTerm)) ||
//           (investor.nationality_origin && investor.nationality_origin.toLowerCase().includes(searchLower)) ||
//           (investor.city && investor.city.toLowerCase().includes(searchLower))
//         );
//       });
//       setFilteredInvestors(filtered);
//     }
//     setPage(0);
//   }, [searchTerm, investorsData]);

//   const handleTabChange = (event, newValue) => {
//     setActiveTab(newValue);
//     if (newValue === 1) {
//       setRefreshKey(prev => prev + 1);
//       setSearchTerm("");
//       setPage(0);
//     } else {
//       resetForm();
//     }
//   };

//   const handleNext = () => {
//     setActiveStep((prevActiveStep) => prevActiveStep + 1);
//   };

//   const handleBack = () => {
//     setActiveStep((prevActiveStep) => prevActiveStep - 1);
//   };

//   const handleReset = () => {
//     setFormData({
//       ...INITIAL_FORM_DATA,
//       registered_by: decodedUser?.full_name || "",
//       reg_date: new Date().toISOString().split('T')[0]
//     });
//     setActiveStep(0);
//     setEditingId(null);
//   };

//   const updateFields = (fields) => {
//     setFormData((prev) => {
//       return { ...prev, ...fields };
//     });
//   };

//   const saveDataToDb = async () => {
//     try {
//       // Ensure registered_by is always set to current user's full name
//       const finalFormData = {
//         ...formData,
//         registered_by: decodedUser?.full_name || formData.registered_by
//       };

//       const formDataToSubmit = new FormData();
//       formDataToSubmit.append("data", JSON.stringify(finalFormData));
      
//       // Append files if they exist and are File objects
//       if (finalFormData.application_file && typeof finalFormData.application_file !== 'string') {
//         formDataToSubmit.append("application", finalFormData.application_file);
//       }
//       if (finalFormData.license && typeof finalFormData.license !== 'string') {
//         formDataToSubmit.append("license", finalFormData.license);
//       }
//       if (finalFormData.propsal_attached && typeof finalFormData.propsal_attached !== 'string') {
//         formDataToSubmit.append("proposal", finalFormData.propsal_attached);
//       }
//       if (finalFormData.legal_documents && typeof finalFormData.legal_documents !== 'string') {
//         formDataToSubmit.append("legal_documents", finalFormData.legal_documents);
//       }
      
//       let response;
//       if (editingId) {
//         // Update existing investor
//         console.log("Updating investor with ID:", editingId);
//         response = await ExecuteApiToPut(`prospectiveInvestors/${editingId}`, formDataToSubmit);
//       } else {
//         // Create new investor
//         response = await ExecuteApiToPost("prospectiveInvestors", formDataToSubmit);
//       }

//       if (response) {
//         setSnackbar({
//           open: true,
//           message: editingId ? 
//             "Prospective investor updated successfully!" : 
//             "Prospective investor registration is successful!",
//           severity: "success"
//         });
//         handleReset();
//         setRefreshKey(prev => prev + 1);
//         setActiveTab(1);
//         return true;
//       } else {
//         setSnackbar({
//           open: true,
//           message: "Registration failed: " + response,
//           severity: "error"
//         });
//         return false;
//       }
//     } catch (error) {
//       setSnackbar({
//         open: true,
//         message: error.message || "An error occurred",
//         severity: "error"
//       });
//       console.error("Error in saveDataToDb:", error);
//       return false;
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (activeStep === steps.length - 1) {
//       await saveDataToDb();
//     } else {
//       handleNext();
//     }
//   };

//   const getStepContent = (step) => {
//     switch (step) {
//       case 0:
//         return <BasicInfo {...formData} updateFields={updateFields} />;
//       case 1:
//         return <PIAddress {...formData} updateFields={updateFields} />;
//       case 2:
//         return <PIAttachment {...formData} updateFields={updateFields} />;
//       default:
//         return "Unknown step";
//     }
//   };

//   const handleEdit = (investor) => {
//     console.log("Editing investor:", investor);
//     setEditingId(investor.id);
    
//     // Parse the documents_attached if it exists
//     let documents = {};
//     if (investor.documents_attached && investor.documents_attached.length > 0) {
//       try {
//         // Handle the JSON string format
//         const docsStr = investor.documents_attached[0];
//         if (docsStr && docsStr !== '{}') {
//           // Parse the JSON string
//           const cleanedStr = docsStr.replace(/\\"/g, '"').replace(/"{/g, '{').replace(/}"/g, '}');
//           documents = JSON.parse(cleanedStr);
//         }
//       } catch (err) {
//         console.error("Error parsing documents:", err);
//       }
//     }
    
//     // Set form data with investor info
//     setFormData({
//       tin_no: investor.tin_no || "0000000000",
//       reg_date: investor.reg_date ? investor.reg_date.split('T')[0] : new Date().toISOString().split('T')[0],
//       registered_by: investor.registered_by || decodedUser?.full_name || "",
//       company_name: investor.company_name || "",
//       contact_person: investor.contact_person || "",
//       phone_no: investor.phone_no || "",
//       email: investor.email || "",
//       website: investor.website || "",
//       nationality_origin: investor.nationality_origin || "",
//       city: investor.city || "",
//       specific_location: investor.specific_location || "",
//       description: investor.description || "",
//       application_file: documents.application || "",
//       license: documents.license || "",
//       propsal_attached: documents.proposal || "",
//       legal_documents: documents.legalDocument || "",
//       documents_attached: investor.documents_attached || []
//     });
    
//     setActiveTab(0);
//     setActiveStep(0);
//   };

//   const handleView = (investor) => {
//     setSelectedInvestor(investor);
//     setViewDialogOpen(true);
//   };

//   const handleDelete = async (id) => {
//     console.log("Attempting to delete investor ID:", id);
    
//     if (window.confirm("Are you sure you want to delete this prospective investor?")) {
//       try {
//         const response = await ExecuteApiToDelete(`prospectiveInvestors/${id}`);
        
//         if (response) {
//           setSnackbar({
//             open: true,
//             message: "Prospective investor deleted successfully!",
//             severity: "success"
//           });
//           setRefreshKey(prev => prev + 1);
//           setSearchTerm("");
//           setPage(0);
//         } else {
//           setSnackbar({
//             open: true,
//             message: "Failed to delete investor",
//             severity: "error"
//           });
//         }
//       } catch (error) {
//         console.error("Error deleting investor:", error);
//         setSnackbar({
//           open: true,
//           message: `Failed to delete investor: ${error.message || "Unknown error"}`,
//           severity: "error"
//         });
//       }
//     }
//   };

//   const handleSearchChange = (event) => {
//     setSearchTerm(event.target.value);
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const exportToExcel = () => {
//     try {
//       const exportData = filteredInvestors.map((investor, index) => ({
//         'No.': index + 1,
//         'ID': investor.id,
//         'Registration Date': formatDate(investor.reg_date),
//         'TIN No': investor.tin_no,
//         'Company Name': investor.company_name,
//         'Contact Person': investor.contact_person,
//         'Phone No': investor.phone_no,
//         'Email': investor.email,
//         'Website': investor.website,
//         'Nationality/Origin': investor.nationality_origin,
//         'City': investor.city,
//         'Specific Location': investor.specific_location,
//         'Description': investor.description,
//         'Registered By': investor.registered_by
//       }));

//       const ws = XLSX.utils.json_to_sheet(exportData);
//       const wb = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(wb, ws, "Prospective Investors");
//       const fileName = `Prospective_Investors_${new Date().toISOString().split('T')[0]}.xlsx`;
//       XLSX.writeFile(wb, fileName);
      
//       setSnackbar({
//         open: true,
//         message: `Exported ${exportData.length} investors to Excel`,
//         severity: "success"
//       });
//     } catch (error) {
//       console.error("Error exporting to Excel:", error);
//       setSnackbar({
//         open: true,
//         message: "Failed to export data to Excel",
//         severity: "error"
//       });
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   const resetForm = () => {
//     setFormData({
//       ...INITIAL_FORM_DATA,
//       registered_by: decodedUser?.full_name || "",
//       reg_date: new Date().toISOString().split('T')[0]
//     });
//     setActiveStep(0);
//     setEditingId(null);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     try {
//       return new Date(dateString).toLocaleDateString();
//     } catch (error) {
//       return dateString;
//     }
//   };

//   const paginatedInvestors = filteredInvestors.slice(
//     page * rowsPerPage,
//     page * rowsPerPage + rowsPerPage
//   );

//   return (
//     <>
//       <Box sx={{ width: '100%' }}>
//         <Tabs 
//           value={activeTab} 
//           onChange={handleTabChange}
//           centered
//           sx={{
//             '& .MuiTabs-flexContainer': {
//               gap: 4,
//             },
//             '& .MuiTabs-indicator': {
//               backgroundColor: 'primary.main',
//             },
//             '& .MuiTab-root': {
//               border: 'none',
//               boxShadow: 'none',
//               minWidth: 'auto',
//               px: 4,
//             }
//           }}
//         >
//           <Tab label={editingId ? "Edit Investor" : "Register Investor"} />
//           <Tab label="Edit Investors" />
//         </Tabs>
        
//         {activeTab === 0 && (
//           <FormContainer 
//             title={editingId ? `Edit Prospective Investor (ID: ${editingId})` : "Prospective Investor Registration"} 
//             onSubmit={handleSubmit}
//             onReset={editingId ? resetForm : null}
//             showResetButton={editingId}
//             resetButtonText="Cancel Edit"
//             showButton={false}
//           >
//             <Grid item xs={12}>
//               <Stepper activeStep={activeStep}>
//                 {steps.map((label, index) => (
//                   <Step key={index}>
//                     <StepLabel>{label}</StepLabel>
//                   </Step>
//                 ))}
//               </Stepper>
//             </Grid>
            
//             {getStepContent(activeStep)}
            
//             <Grid item xs={12}>
//               <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
//                 <Button 
//                   disabled={activeStep === 0} 
//                   onClick={handleBack} 
//                   sx={{ mr: 1 }}
//                 >
//                   Back
//                 </Button>
//                 <Button type="submit" variant="contained" color="primary">
//                   {activeStep === steps.length - 1 ? 
//                     (editingId ? "Update" : "Register") : 
//                     "Next"
//                   }
//                 </Button>
//                 {editingId && (
//                   <Button 
//                     onClick={resetForm}
//                     sx={{ ml: 1 }}
//                     color="secondary"
//                   >
//                     Cancel Edit
//                   </Button>
//                 )}
//               </Box>
//             </Grid>
//           </FormContainer>
//         )}
        
//         {activeTab === 1 && (
//           <Box sx={{ mt: 3 }}>
//             <Typography variant="h5" gutterBottom>
//               Registered Prospective Investors
//             </Typography>
            
//             {/* Search Box */}
//             <Box sx={{ width: '100%', mb: 3 }}>
//               <TextField
//                 variant="outlined"
//                 placeholder="Search investors by company name, contact person, TIN, email..."
//                 value={searchTerm}
//                 onChange={handleSearchChange}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <SearchIcon />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{ width: '50%' }}
//                 size="small"
//               />
//             </Box>
            
//             {/* Info and Export Section */}
//             <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'space-between', 
//               alignItems: 'center', 
//               mb: 2 
//             }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 110 }}>
//                 <Typography variant="body2" color="text.secondary">
//                   Showing {paginatedInvestors.length} of {filteredInvestors.length} investors
//                   {searchTerm && ` matching "${searchTerm}"`}
//                 </Typography>
//                 <Tooltip title="Export to Excel">
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     startIcon={<DownloadIcon />}
//                     onClick={exportToExcel}
//                     disabled={filteredInvestors.length === 0}
//                     size="small"
//                   >
//                     Export
//                   </Button>
//                 </Tooltip>
//               </Box>
              
//               {searchTerm && (
//                 <Button 
//                   variant="outlined" 
//                   size="small"
//                   onClick={() => setSearchTerm("")}
//                 >
//                   Clear Search
//                 </Button>
//               )}
//             </Box>
            
//             {loadingInvestors ? (
//               <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
//                 <CircularProgress />
//               </Box>
//             ) : filteredInvestors.length === 0 ? (
//               <Box sx={{ textAlign: 'center', mt: 4 }}>
//                 <Typography variant="body1" color="text.secondary">
//                   {searchTerm ? 
//                     `No investors found matching "${searchTerm}"` : 
//                     "No prospective investors registered yet."
//                   }
//                 </Typography>
//                 {searchTerm && (
//                   <Button 
//                     variant="text" 
//                     onClick={() => setSearchTerm("")}
//                     sx={{ mt: 1 }}
//                   >
//                     Clear search
//                   </Button>
//                 )}
//               </Box>
//             ) : (
//               <>
//                 <Box sx={{ ml: 2 }}>
//                   <TableContainer component={Paper}>
//                     <Table>
//                       <TableHead>
//                         <TableRow>
//                           <TableCell><strong>ID</strong></TableCell>
//                           <TableCell>Reg Date</TableCell>
//                           <TableCell>TIN No</TableCell>
//                           <TableCell>Company Name</TableCell>
//                           <TableCell>Contact Person</TableCell>
//                           <TableCell>Phone No</TableCell>
//                           <TableCell>Email</TableCell>
//                           <TableCell>City</TableCell>
//                           <TableCell>Actions</TableCell>
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {paginatedInvestors.map((investor) => (
//                           <TableRow key={investor.id}>
//                             <TableCell><strong>{investor.id}</strong></TableCell>
//                             <TableCell>{formatDate(investor.reg_date)}</TableCell>
//                             <TableCell>
//                               <Chip 
//                                 label={investor.tin_no || "0000000000"} 
//                                 size="small" 
//                                 variant="outlined"
//                               />
//                             </TableCell>
//                             <TableCell>{investor.company_name}</TableCell>
//                             <TableCell>{investor.contact_person}</TableCell>
//                             <TableCell>{investor.phone_no}</TableCell>
//                             <TableCell>{investor.email}</TableCell>
//                             <TableCell>{investor.city}</TableCell>
//                             <TableCell>
//                               <IconButton 
//                                 color="primary" 
//                                 onClick={() => handleView(investor)}
//                                 size="small"
//                                 title="View Details"
//                               >
//                                 <ViewIcon />
//                               </IconButton>
//                               <IconButton 
//                                 color="secondary" 
//                                 onClick={() => handleEdit(investor)}
//                                 size="small"
//                                 title="Edit"
//                               >
//                                 <EditIcon />
//                               </IconButton>
//                               <IconButton 
//                                 color="error" 
//                                 onClick={() => handleDelete(investor.id)}
//                                 size="small"
//                                 title="Delete"
//                               >
//                                 <DeleteIcon />
//                               </IconButton>
//                             </TableCell>
//                           </TableRow>
//                         ))}
//                       </TableBody>
//                     </Table>
                    
//                     <TablePagination
//                       rowsPerPageOptions={[5, 10, 25, 50, 100]}
//                       component="div"
//                       count={filteredInvestors.length}
//                       rowsPerPage={rowsPerPage}
//                       page={page}
//                       onPageChange={handleChangePage}
//                       onRowsPerPageChange={handleChangeRowsPerPage}
//                       labelRowsPerPage="Rows per page:"
//                     />
//                   </TableContainer>
//                 </Box>
//               </>
//             )}
//           </Box>
//         )}
//       </Box>

//       {/* View Dialog */}
//       <Dialog 
//         open={viewDialogOpen} 
//         onClose={() => setViewDialogOpen(false)}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>Prospective Investor Details</DialogTitle>
//         <DialogContent>
//           {selectedInvestor && (
//             <Grid container spacing={2} sx={{ mt: 1 }}>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="text.secondary">ID</Typography>
//                 <Typography variant="body1"><strong>{selectedInvestor.id}</strong></Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="text.secondary">Registration Date</Typography>
//                 <Typography variant="body1">{formatDate(selectedInvestor.reg_date)}</Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="text.secondary">TIN No</Typography>
//                 <Typography variant="body1">{selectedInvestor.tin_no || "0000000000"}</Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="text.secondary">Registered By</Typography>
//                 <Typography variant="body1">{selectedInvestor.registered_by}</Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="text.secondary">Company Name</Typography>
//                 <Typography variant="body1">{selectedInvestor.company_name}</Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="text.secondary">Contact Person</Typography>
//                 <Typography variant="body1">{selectedInvestor.contact_person}</Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="text.secondary">Phone No</Typography>
//                 <Typography variant="body1">{selectedInvestor.phone_no}</Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="text.secondary">Email</Typography>
//                 <Typography variant="body1">{selectedInvestor.email}</Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="text.secondary">Website</Typography>
//                 <Typography variant="body1">{selectedInvestor.website || "N/A"}</Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="text.secondary">Nationality/Origin</Typography>
//                 <Typography variant="body1">{selectedInvestor.nationality_origin}</Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="text.secondary">City</Typography>
//                 <Typography variant="body1">{selectedInvestor.city || "N/A"}</Typography>
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle2" color="text.secondary">Specific Location</Typography>
//                 <Typography variant="body1">{selectedInvestor.specific_location || "N/A"}</Typography>
//               </Grid>
//               <Grid item xs={12}>
//                 <Typography variant="subtitle2" color="text.secondary">Description</Typography>
//                 <Typography variant="body1">{selectedInvestor.description || "N/A"}</Typography>
//               </Grid>
//               <Grid item xs={12}>
//                 <Typography variant="subtitle2" color="text.secondary">Documents Attached</Typography>
//                 <Typography variant="body1">
//                   {selectedInvestor.documents_attached && selectedInvestor.documents_attached.length > 0 ? 
//                     JSON.stringify(selectedInvestor.documents_attached) : 
//                     "No documents attached"}
//                 </Typography>
//               </Grid>
//             </Grid>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setViewDialogOpen(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Snackbar for notifications */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//         message={snackbar.message}
//       />
//     </>
//   );
// };

// export default RegisterProspectiveInvestor;

//*******************New code Error fixed */
import { useState, useEffect } from "react";
//prettier-ignore
import { 
  Box, Button, Step, StepLabel, Stepper, Grid, 
  Typography, Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Paper, IconButton, Dialog, DialogTitle, 
  DialogContent, DialogActions, Snackbar, InputAdornment, 
  TablePagination, Tooltip, Tabs, Tab, TextField, Chip,
  CircularProgress
} from "@mui/material";
import { Edit as EditIcon, Visibility as ViewIcon, Delete as DeleteIcon, Search as SearchIcon, Download as DownloadIcon } from "@mui/icons-material";
import * as XLSX from 'xlsx';
import { 
  ExecuteApiToPost, 
  UpdateAndGetResponse, 
  DeleteAndGetResponse, 
  GetDataFromApiWithParamsAndGetResponse 
} from "../../../../services/api/ExecuteApiRequests";
import BasicInfo from "./RegisterProspectiveInvestor/BasicInfo";
import PIAddress from "./RegisterProspectiveInvestor/PIAddress";
import PIAttachment from "./RegisterProspectiveInvestor/PIAttachment";
import FormContainer from "../../../../components/Forms/FormContainer";
import useDecodedUser from "../../../../services/hooks/useDecodedUser";

//prettier-ignore
const INITIAL_FORM_DATA = { 
  id: "", 
  tin_no: "0000000000", 
  reg_date: "", 
  registered_by: "", 
  company_name: "", 
  contact_person: "", 
  phone_no: "", 
  email: "", 
  website: "", 
  nationality_origin: "", 
  city: "", 
  specific_location: "", 
  description: "",
  application_file: "", 
  license: "", 
  propsal_attached: "", 
  legal_documents: "",
  documents_attached: []
};

const steps = ["Basic Info", "PI Address", "PI Attachment"];

const RegisterProspectiveInvestor = () => {
  const decodedUser = useDecodedUser();
  const [activeTab, setActiveTab] = useState(0);
  const [formData, setFormData] = useState({
    ...INITIAL_FORM_DATA,
    registered_by: decodedUser?.full_name || "",
    reg_date: new Date().toISOString().split('T')[0]
  });
  const [activeStep, setActiveStep] = useState(0);
  const [investorsData, setInvestorsData] = useState([]);
  const [filteredInvestors, setFilteredInvestors] = useState([]);
  const [loadingInvestors, setLoadingInvestors] = useState(false);
  const [selectedInvestor, setSelectedInvestor] = useState(null);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [editingId, setEditingId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Fetch investors data
  useEffect(() => {
    const fetchInvestors = async () => {
      try {
        setLoadingInvestors(true);
        const response = await GetDataFromApiWithParamsAndGetResponse("prospectiveInvestors");
        
        if (response && response.data) {
          setInvestorsData(response.data);
          setFilteredInvestors(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch prospective investors:", error);
        setSnackbar({
          open: true,
          message: "Failed to load investors data",
          severity: "error"
        });
      } finally {
        setLoadingInvestors(false);
      }
    };

    if (activeTab === 1) {
      fetchInvestors();
    }
  }, [refreshKey, activeTab]);

  // Handle search functionality
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredInvestors(investorsData);
    } else {
      const filtered = investorsData.filter(investor => {
        const searchLower = searchTerm.toLowerCase();
        return (
          (investor.company_name && investor.company_name.toLowerCase().includes(searchLower)) ||
          (investor.contact_person && investor.contact_person.toLowerCase().includes(searchLower)) ||
          (investor.tin_no && investor.tin_no.includes(searchTerm)) ||
          (investor.email && investor.email.toLowerCase().includes(searchLower)) ||
          (investor.phone_no && investor.phone_no.includes(searchTerm)) ||
          (investor.nationality_origin && investor.nationality_origin.toLowerCase().includes(searchLower)) ||
          (investor.city && investor.city.toLowerCase().includes(searchLower))
        );
      });
      setFilteredInvestors(filtered);
    }
    setPage(0);
  }, [searchTerm, investorsData]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    if (newValue === 1) {
      setRefreshKey(prev => prev + 1);
      setSearchTerm("");
      setPage(0);
    } else {
      resetForm();
    }
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setFormData({
      ...INITIAL_FORM_DATA,
      registered_by: decodedUser?.full_name || "",
      reg_date: new Date().toISOString().split('T')[0]
    });
    setActiveStep(0);
    setEditingId(null);
  };

  const updateFields = (fields) => {
    setFormData((prev) => {
      return { ...prev, ...fields };
    });
  };

  const saveDataToDb = async () => {
    try {
      // Ensure registered_by is always set to current user's full name
      const finalFormData = {
        ...formData,
        registered_by: decodedUser?.full_name || formData.registered_by
      };

      const formDataToSubmit = new FormData();
      formDataToSubmit.append("data", JSON.stringify(finalFormData));
      
      // Append files if they exist and are File objects
      if (finalFormData.application_file && typeof finalFormData.application_file !== 'string') {
        formDataToSubmit.append("application", finalFormData.application_file);
      }
      if (finalFormData.license && typeof finalFormData.license !== 'string') {
        formDataToSubmit.append("license", finalFormData.license);
      }
      if (finalFormData.propsal_attached && typeof finalFormData.propsal_attached !== 'string') {
        formDataToSubmit.append("proposal", finalFormData.propsal_attached);
      }
      if (finalFormData.legal_documents && typeof finalFormData.legal_documents !== 'string') {
        formDataToSubmit.append("legal_documents", finalFormData.legal_documents);
      }
      
      let response;
      if (editingId) {
        // Update existing investor
        console.log("Updating investor with ID:", editingId);
        response = await UpdateAndGetResponse(`prospectiveInvestors/${editingId}`, formDataToSubmit);
      } else {
        // Create new investor
        response = await ExecuteApiToPost("prospectiveInvestors", formDataToSubmit);
      }

      if (response) {
        setSnackbar({
          open: true,
          message: editingId ? 
            "Prospective investor updated successfully!" : 
            "Prospective investor registration is successful!",
          severity: "success"
        });
        handleReset();
        setRefreshKey(prev => prev + 1);
        setActiveTab(1);
        return true;
      } else {
        setSnackbar({
          open: true,
          message: "Registration failed: " + response,
          severity: "error"
        });
        return false;
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message || "An error occurred",
        severity: "error"
      });
      console.error("Error in saveDataToDb:", error);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (activeStep === steps.length - 1) {
      await saveDataToDb();
    } else {
      handleNext();
    }
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return <BasicInfo {...formData} updateFields={updateFields} />;
      case 1:
        return <PIAddress {...formData} updateFields={updateFields} />;
      case 2:
        return <PIAttachment {...formData} updateFields={updateFields} />;
      default:
        return "Unknown step";
    }
  };

  const handleEdit = (investor) => {
    console.log("Editing investor:", investor);
    setEditingId(investor.id);
    
    // Parse the documents_attached if it exists
    let documents = {};
    if (investor.documents_attached && investor.documents_attached.length > 0) {
      try {
        // Handle the JSON string format
        const docsStr = investor.documents_attached[0];
        if (docsStr && docsStr !== '{}') {
          // Parse the JSON string
          const cleanedStr = docsStr.replace(/\\"/g, '"').replace(/"{/g, '{').replace(/}"/g, '}');
          documents = JSON.parse(cleanedStr);
        }
      } catch (err) {
        console.error("Error parsing documents:", err);
      }
    }
    
    // Set form data with investor info
    setFormData({
      tin_no: investor.tin_no || "0000000000",
      reg_date: investor.reg_date ? investor.reg_date.split('T')[0] : new Date().toISOString().split('T')[0],
      registered_by: investor.registered_by || decodedUser?.full_name || "",
      company_name: investor.company_name || "",
      contact_person: investor.contact_person || "",
      phone_no: investor.phone_no || "",
      email: investor.email || "",
      website: investor.website || "",
      nationality_origin: investor.nationality_origin || "",
      city: investor.city || "",
      specific_location: investor.specific_location || "",
      description: investor.description || "",
      application_file: documents.application || "",
      license: documents.license || "",
      propsal_attached: documents.proposal || "",
      legal_documents: documents.legalDocument || "",
      documents_attached: investor.documents_attached || []
    });
    
    setActiveTab(0);
    setActiveStep(0);
  };

  const handleView = (investor) => {
    setSelectedInvestor(investor);
    setViewDialogOpen(true);
  };

  const handleDelete = async (id) => {
    console.log("Attempting to delete investor ID:", id);
    
    if (window.confirm("Are you sure you want to delete this prospective investor?")) {
      try {
        const response = await DeleteAndGetResponse(`prospectiveInvestors/${id}`);
        
        if (response) {
          setSnackbar({
            open: true,
            message: "Prospective investor deleted successfully!",
            severity: "success"
          });
          setRefreshKey(prev => prev + 1);
          setSearchTerm("");
          setPage(0);
        } else {
          setSnackbar({
            open: true,
            message: "Failed to delete investor",
            severity: "error"
          });
        }
      } catch (error) {
        console.error("Error deleting investor:", error);
        setSnackbar({
          open: true,
          message: `Failed to delete investor: ${error.message || "Unknown error"}`,
          severity: "error"
        });
      }
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const exportToExcel = () => {
    try {
      const exportData = filteredInvestors.map((investor, index) => ({
        'No.': index + 1,
        'ID': investor.id,
        'Registration Date': formatDate(investor.reg_date),
        'TIN No': investor.tin_no,
        'Company Name': investor.company_name,
        'Contact Person': investor.contact_person,
        'Phone No': investor.phone_no,
        'Email': investor.email,
        'Website': investor.website,
        'Nationality/Origin': investor.nationality_origin,
        'City': investor.city,
        'Specific Location': investor.specific_location,
        'Description': investor.description,
        'Registered By': investor.registered_by
      }));

      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Prospective Investors");
      const fileName = `Prospective_Investors_${new Date().toISOString().split('T')[0]}.xlsx`;
      XLSX.writeFile(wb, fileName);
      
      setSnackbar({
        open: true,
        message: `Exported ${exportData.length} investors to Excel`,
        severity: "success"
      });
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      setSnackbar({
        open: true,
        message: "Failed to export data to Excel",
        severity: "error"
      });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const resetForm = () => {
    setFormData({
      ...INITIAL_FORM_DATA,
      registered_by: decodedUser?.full_name || "",
      reg_date: new Date().toISOString().split('T')[0]
    });
    setActiveStep(0);
    setEditingId(null);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      return new Date(dateString).toLocaleDateString();
    } catch (error) {
      return dateString;
    }
  };

  const paginatedInvestors = filteredInvestors.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Tabs 
          value={activeTab} 
          onChange={handleTabChange}
          centered
          sx={{
            '& .MuiTabs-flexContainer': {
              gap: 4,
            },
            '& .MuiTabs-indicator': {
              backgroundColor: 'primary.main',
            },
            '& .MuiTab-root': {
              border: 'none',
              boxShadow: 'none',
              minWidth: 'auto',
              px: 4,
            }
          }}
        >
          <Tab label={editingId ? "Edit Investor" : "Register Investor"} />
          <Tab label="Edit Investors" />
        </Tabs>
        
        {activeTab === 0 && (
          <FormContainer 
            title={editingId ? `Edit Prospective Investor (ID: ${editingId})` : "Prospective Investor Registration"} 
            onSubmit={handleSubmit}
            onReset={editingId ? resetForm : null}
            showResetButton={editingId}
            resetButtonText="Cancel Edit"
            showButton={false}
          >
            <Grid item xs={12}>
              <Stepper activeStep={activeStep}>
                {steps.map((label, index) => (
                  <Step key={index}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Grid>
            
            {getStepContent(activeStep)}
            
            <Grid item xs={12}>
              <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                <Button 
                  disabled={activeStep === 0} 
                  onClick={handleBack} 
                  sx={{ mr: 1 }}
                >
                  Back
                </Button>
                <Button type="submit" variant="contained" color="primary">
                  {activeStep === steps.length - 1 ? 
                    (editingId ? "Update" : "Register") : 
                    "Next"
                  }
                </Button>
                {editingId && (
                  <Button 
                    onClick={resetForm}
                    sx={{ ml: 1 }}
                    color="secondary"
                  >
                    Cancel Edit
                  </Button>
                )}
              </Box>
            </Grid>
          </FormContainer>
        )}
        
        {activeTab === 1 && (
          <Box sx={{ mt: 3 }}>
            <Typography variant="h5" gutterBottom>
              Registered Prospective Investors
            </Typography>
            
            {/* Search Box */}
            <Box sx={{ width: '100%', mb: 3 }}>
              <TextField
                variant="outlined"
                placeholder="Search investors by company name, contact person, TIN, email..."
                value={searchTerm}
                onChange={handleSearchChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                sx={{ width: '50%' }}
                size="small"
              />
            </Box>
            
            {/* Info and Export Section */}
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
              mb: 2 
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 110 }}>
                <Typography variant="body2" color="text.secondary">
                  Showing {paginatedInvestors.length} of {filteredInvestors.length} investors
                  {searchTerm && ` matching "${searchTerm}"`}
                </Typography>
                <Tooltip title="Export to Excel">
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<DownloadIcon />}
                    onClick={exportToExcel}
                    disabled={filteredInvestors.length === 0}
                    size="small"
                  >
                    Export
                  </Button>
                </Tooltip>
              </Box>
              
              {searchTerm && (
                <Button 
                  variant="outlined" 
                  size="small"
                  onClick={() => setSearchTerm("")}
                >
                  Clear Search
                </Button>
              )}
            </Box>
            
            {loadingInvestors ? (
              <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
                <CircularProgress />
              </Box>
            ) : filteredInvestors.length === 0 ? (
              <Box sx={{ textAlign: 'center', mt: 4 }}>
                <Typography variant="body1" color="text.secondary">
                  {searchTerm ? 
                    `No investors found matching "${searchTerm}"` : 
                    "No prospective investors registered yet."
                  }
                </Typography>
                {searchTerm && (
                  <Button 
                    variant="text" 
                    onClick={() => setSearchTerm("")}
                    sx={{ mt: 1 }}
                  >
                    Clear search
                  </Button>
                )}
              </Box>
            ) : (
              <>
                <Box sx={{ ml: 2 }}>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell><strong>ID</strong></TableCell>
                          <TableCell>Reg Date</TableCell>
                          <TableCell>TIN No</TableCell>
                          <TableCell>Company Name</TableCell>
                          <TableCell>Contact Person</TableCell>
                          <TableCell>Phone No</TableCell>
                          <TableCell>Email</TableCell>
                          <TableCell>City</TableCell>
                          <TableCell>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {paginatedInvestors.map((investor) => (
                          <TableRow key={investor.id}>
                            <TableCell><strong>{investor.id}</strong></TableCell>
                            <TableCell>{formatDate(investor.reg_date)}</TableCell>
                            <TableCell>
                              <Chip 
                                label={investor.tin_no || "0000000000"} 
                                size="small" 
                                variant="outlined"
                              />
                            </TableCell>
                            <TableCell>{investor.company_name}</TableCell>
                            <TableCell>{investor.contact_person}</TableCell>
                            <TableCell>{investor.phone_no}</TableCell>
                            <TableCell>{investor.email}</TableCell>
                            <TableCell>{investor.city}</TableCell>
                            <TableCell>
                              <IconButton 
                                color="primary" 
                                onClick={() => handleView(investor)}
                                size="small"
                                title="View Details"
                              >
                                <ViewIcon />
                              </IconButton>
                              <IconButton 
                                color="secondary" 
                                onClick={() => handleEdit(investor)}
                                size="small"
                                title="Edit"
                              >
                                <EditIcon />
                              </IconButton>
                              <IconButton 
                                color="error" 
                                onClick={() => handleDelete(investor.id)}
                                size="small"
                                title="Delete"
                              >
                                <DeleteIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, 50, 100]}
                      component="div"
                      count={filteredInvestors.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      labelRowsPerPage="Rows per page:"
                    />
                  </TableContainer>
                </Box>
              </>
            )}
          </Box>
        )}
      </Box>

      {/* View Dialog */}
      <Dialog 
        open={viewDialogOpen} 
        onClose={() => setViewDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Prospective Investor Details</DialogTitle>
        <DialogContent>
          {selectedInvestor && (
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" color="text.secondary">ID</Typography>
                <Typography variant="body1"><strong>{selectedInvestor.id}</strong></Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" color="text.secondary">Registration Date</Typography>
                <Typography variant="body1">{formatDate(selectedInvestor.reg_date)}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" color="text.secondary">TIN No</Typography>
                <Typography variant="body1">{selectedInvestor.tin_no || "0000000000"}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" color="text.secondary">Registered By</Typography>
                <Typography variant="body1">{selectedInvestor.registered_by}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" color="text.secondary">Company Name</Typography>
                <Typography variant="body1">{selectedInvestor.company_name}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" color="text.secondary">Contact Person</Typography>
                <Typography variant="body1">{selectedInvestor.contact_person}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" color="text.secondary">Phone No</Typography>
                <Typography variant="body1">{selectedInvestor.phone_no}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" color="text.secondary">Email</Typography>
                <Typography variant="body1">{selectedInvestor.email}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" color="text.secondary">Website</Typography>
                <Typography variant="body1">{selectedInvestor.website || "N/A"}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" color="text.secondary">Nationality/Origin</Typography>
                <Typography variant="body1">{selectedInvestor.nationality_origin}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" color="text.secondary">City</Typography>
                <Typography variant="body1">{selectedInvestor.city || "N/A"}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle2" color="text.secondary">Specific Location</Typography>
                <Typography variant="body1">{selectedInvestor.specific_location || "N/A"}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="text.secondary">Description</Typography>
                <Typography variant="body1">{selectedInvestor.description || "N/A"}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="text.secondary">Documents Attached</Typography>
                <Typography variant="body1">
                  {selectedInvestor.documents_attached && selectedInvestor.documents_attached.length > 0 ? 
                    JSON.stringify(selectedInvestor.documents_attached) : 
                    "No documents attached"}
                </Typography>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setViewDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        message={snackbar.message}
      />
    </>
  );
};

export default RegisterProspectiveInvestor;